import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { CircularProgress } from 'shared/mui/CircularProgress/CircularProgress';
import { DialogProps } from 'shared/mui/Dialogs';
import { BaseDialog } from 'shared/mui/Dialogs';

export type NotifyDialogProps = {
  isLoading?: boolean;
  title: React.ReactNode;
  message: JSX.Element;
  onSubmit: () => void;
  acceptButtonTitle?: string;
  onClose: () => void;
} & Omit<DialogProps, 'title'>;

export const NotifyDialog = ({
  acceptButtonTitle,
  isLoading,
  open,
  onClose,
  message,
  onSubmit,
  title,
  ...restProps
}: NotifyDialogProps): JSX.Element => {
  const translate = useTypedTranslate();

  return (
    <BaseDialog
      message={message}
      onClose={onClose}
      open={open}
      rightActionsSlot={[
        <CancelButton
          key="cancel-button"
          label={translate('app.buttons.cancel')}
          onClick={onClose}
          variant="outlined"
        />,
        <Button
          disabled={isLoading}
          key="accept-button"
          label={
            isLoading
              ? translate('app.buttons.loading')
              : acceptButtonTitle || translate('app.buttons.approve')
          }
          onClick={onSubmit}
          startIcon={isLoading && <CircularProgress color="primary" size={25} />}
          variant="contained"
        />,
      ]}
      title={title}
      {...restProps}
    />
  );
};
